export default {
  name: 'FooterToolBar'
};